import { Controller } from "@hotwired/stimulus";

// Outer training controller — page-level concerns. Lives on the
// `.lc-training` wrapper which is OUTSIDE the Turbo Frame, so it stays
// connected across lesson changes. The actual timer (which is bound to
// the *current* lesson) lives inside the lesson controller so it gets
// re-initialised on every frame swap.
//
// Here we only listen for child events:
//   • `lc-training-element:progress-changed` — bubbled from QCM/depot/video
//     so we can refresh the topbar progress bar without a full reload.
export default class extends Controller {
  static values = {
    juniorId:   String,
    userId:     String,
    lessonId:   String,
    progressId: String
  };
  static targets = ["coursePct", "courseBar", "lessonPct"];

  connect() {
    this._progressListener = (event) => this._onProgressChanged(event);
    this.element.addEventListener("lc-training:progress-changed", this._progressListener);
  }

  disconnect() {
    this.element.removeEventListener("lc-training:progress-changed", this._progressListener);
  }

  _onProgressChanged(event) {
    const detail = event.detail || {};
    if (typeof detail.lessonProgressPct === "number" && this.hasLessonPctTarget) {
      this.lessonPctTarget.textContent = String(detail.lessonProgressPct);
    }
    if (typeof detail.coursePct === "number") {
      if (this.hasCoursePctTarget) this.coursePctTarget.textContent = `${detail.coursePct}%`;
      if (this.hasCourseBarTarget) this.courseBarTarget.style.width = `${Math.min(detail.coursePct, 100)}%`;
    }
  }
}
